import { useMemo, useState } from 'react';
import _ from 'lodash';
import SelectTile from '../webapp/core/SelectTile';
import Backdrop from './Backdrop';
import { randomBetween } from '../../utils/utils';

const StickersDemo = ({ stickers = [], backdrop }) => {
  const enabledStickerUrls = useMemo(() => {
    const filtered = stickers.filter((sticker) => sticker.enabled).map((sticker) => sticker.url);
    return _.take(filtered, 3);
  }, [JSON.stringify(stickers)]);

  const modelUrl = useMemo(() => {
    const modelIdx = randomBetween(0, 3);
    const puctureIdx = randomBetween(0, 3);
    return `/static/model/${modelIdx}/${puctureIdx}.png`;
  }, []);

  const [currentStickerUrl, setCurrentStickerUrl] = useState(enabledStickerUrls[0]);

  const handleStickerUrlChange = (selectedSticker) => {
    if (selectedSticker) {
      setCurrentStickerUrl(selectedSticker.id);
    }
  };

  return (
    <div className="face-effect-demo">
      <div className="video-demo face-effect-demo__capture">
        <Backdrop backdrop={backdrop} animated={false} />
        <img className="video-demo__photo" src={modelUrl} alt="" />
        <img
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100px',
            height: '100px',
          }}
          src={currentStickerUrl}
        />
      </div>
      {enabledStickerUrls.length > 1 && (
        <div className="face-effect-demo__controls">
          {enabledStickerUrls.map((enabledStickerUrl) => (
            <SelectTile
              key={enabledStickerUrl}
              id={enabledStickerUrl}
              name="sticker"
              type="radio"
              labelHidden={true}
              autoHeight={true}
              onChange={handleStickerUrlChange}
              selected={currentStickerUrl === enabledStickerUrl}
            >
              <img src={enabledStickerUrl} />
            </SelectTile>
          ))}
        </div>
      )}
    </div>
  );
};

export default StickersDemo;
